module.exports = __webpack_public_path__ + "img/time_between_hover.fdb6f9ef.svg";